import { useEffect, useState } from "react";
import { PrimaryButton } from "../../components/buttons/AmeButton";
import CustomizedCardHeader from "../../components/customized-card-header/CustomizedCardHeader";
import {
    CustomizedCard,
    CustomizedCardBody,
    FormGroup,
    Input,
    Label
} from "./styles";
import { GenericAlert } from "../../components/alert/GenericAlert";
import ScopeService from "../../services/scope-service/ScopeService";
import DynamicBreadcrumb from "../../components/dynamic-breadcrumb/DynamicBreadcrumb";
import { useMountBreadCrumb } from "../../hooks/useMountBreadCrumb";

const CreateScopeView = () => {
    const { setBreadCrumb } = useMountBreadCrumb();
    const initialStatusAlert = {
        theme: "",
        message: "",
        isOpen: false
    };

    const [statusAlert, setStatusAlert] = useState(initialStatusAlert);
    const [data, setData] = useState({
        name: "",
        description: ""
    });
    const [isFetching, setIsFetching] = useState(false);

    const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
        setData({
            ...data,
            [event.target.name]: event.target.value
        });
    };

    const onSubmit = async () => {
        let isOK = false;
        Object.entries(data).forEach(([, value]) => {
            if (value === "" || !value) {
                isOK = false;
            } else {
                isOK = true;
            }
        });

        if (!isOK) {
            setStatusAlert({
                message:
                    "Campos do formulário podem estar inválidos, verifique-os novamente.",
                theme: "danger",
                isOpen: true
            });
            return;
        }

        setIsFetching(true);
        await ScopeService.createScope(data);
        setStatusAlert({
            message: "Escopo cadastrado com sucesso!",
            theme: "success",
            isOpen: true
        });
        setIsFetching(false);
    };

    const closeAlert = () => {
        setStatusAlert(initialStatusAlert);
    };

    const getBreadCrumbList = () => {
        const authBreadCrumbItem = {
            pathname: `/auth`,
            label: "Segurança"
        };
        const scopesBreadCrumbItem = {
            pathname: `/auth/scopes`,
            label: "Escopos"
        };
        const createScopesBreadCrumbItem = {
            pathname: `/auth/scopes/create`,
            label: "Cadastrar Escopo"
        };
        const breadCrumbList = [
            authBreadCrumbItem,
            scopesBreadCrumbItem,
            createScopesBreadCrumbItem
        ];
        return breadCrumbList;
    };

    const mountBreadCrumb = () => {
        const list = getBreadCrumbList();
        return <DynamicBreadcrumb breadCrumbList={list} />;
    };

    useEffect(() => {
        setBreadCrumb(mountBreadCrumb());
    }, []);

    return (
        <>
            <GenericAlert
                className="mb-3 cypreGenericAlert"
                dismissible={() => closeAlert()}
                open={statusAlert.isOpen}
                theme={statusAlert.theme}
            >
                {statusAlert.message}
            </GenericAlert>
            <CustomizedCard>
                <CustomizedCardHeader
                    className={"border-bottom"}
                    initialName={`Cadastrar novo Escopo`}
                />
                <CustomizedCardBody>
                    {isFetching ? (
                        <div className="loading--container">
                            <div className="lds-dual-ring"></div>
                            <h1 className="loading--text">Carregando...</h1>
                        </div>
                    ) : (
                        <FormGroup>
                            <Label>Nome:</Label>
                            <Input
                                name="name"
                                placeholder="Exemplo: meu_novo_escopo"
                                onChange={onChangeText}
                            />
                            <Label>Descrição:</Label>
                            <Input
                                name="description"
                                placeholder="Exemplo: Descrição do meu novo target"
                                onChange={onChangeText}
                            />
                            <PrimaryButton
                                style={{ marginTop: 32 }}
                                onClick={() => onSubmit()}
                            >
                                Salvar
                            </PrimaryButton>
                        </FormGroup>
                    )}
                </CustomizedCardBody>
            </CustomizedCard>
        </>
    );
};

export default CreateScopeView;
